export const CrossTabStateKeys = Object.freeze({
  /* tab Id representing the currently playing tab */
  XTAB_CURRENTLY_PLAYING_TAB_ID: 'XTAB_CURRENTLY_PLAYING_TAB_ID',
  /* tab Id representing this tab */
  XTAB_MY_TAB_ID: 'XTAB_MY_TAB_ID',
} as const);

export const CrossTabActions = Object.freeze({
  SET_XTAB_CURRENTLY_PLAYING_TAB_ID: 'SET_XTAB_CURRENTLY_PLAYING_TAB_ID',
  SET_XTAB_MY_TAB_ID: 'SET_XTAB_MY_TAB_ID',
} as const);

export const GIVE_UP_XTAB_PAUSE_AFTER = 2000 as const; // if another tab is the currently active tab, give up attempting to pause it after x milliseconds
